<article class="real-estate-teaser"
         *ngIf="slideForward; else slideBackward"
         [@.disabled]="true"
         [@slideInFromRight]="visibility"
         (@slideInFromRight.done)="animationDone($event)"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</article>

<ng-template #slideBackward>
  <article class="real-estate-teaser"
           [@.disabled]="true"
           [@slideInFromLeft]="visibility"
           (@slideInFromLeft.done)="animationDone($event)"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </article>
</ng-template>

<!--shared content-->
<ng-template #content>
  <ed-clients-lazy-sw-picture
    class="image bg-light-gray cover"
    [swMedia]="data.cover" thumbSize="800"
  ></ed-clients-lazy-sw-picture>

  <div class="text">
    <h3 class="title">{{ data.title }}</h3>
    <div class="real-estate-address">
      <svg class="real-estate-address-icon" role="img" focusable="false">
        <use href="#dwg-icon-location"></use>
      </svg>
      <span> {{data.address?.street}} {{data.address?.houseNumber}}</span>,
      <span>Dorsten, Deutschland</span>
    </div>

    <dl class="real-estate-teaser-price">
      <dt class="real-estate-teaser-price-value">{{ data.baseRent | currency:data.currency:'symbol':'2.0' }}</dt>
      <dd class="real-estate-teaser-price-unit">&nbsp;/ Monat (zzgl. Nebenkosten)</dd>
    </dl>

    <div class="description">{{ data.description }}</div>

    <dl class="real-estate-details">
      <div class="real-estate-detail detail-living-space">
        <dt class="real-estate-detail-name">Wohnfläche</dt>
        <dd class="real-estate-detail-value">{{data.livingSpaceInSquareMeters}} &#13217;</dd>
      </div>
      <div class="real-estate-detail detail-number-of-rooms">
        <dt class="real-estate-detail-name">Zimmer</dt>
        <dd class="real-estate-detail-value">{{data.numberOfRooms}}</dd>
      </div>
    </dl>

    <a class="link cta cta-secondary" [routerLink]="data.link">
      <span class="link-label">{{ data.buttonText }}</span>
    </a>
  </div>
</ng-template>





